import { LIVE_CLASS_LOCKED_STATE_KEYS } from '../../../shared/types/live-class-locked-state-keys';
import { LiveClassEventDto } from '../../live-class-event-dto';
import { LiveClassTile } from './live-class-tile';

export class GroupClassTile extends LiveClassTile {
  protected onComplete(): void {
    this.liveClassEventSubscription.unsubscribe();
    this.setLockedState(LIVE_CLASS_LOCKED_STATE_KEYS.GROUP_COMPLETE[this.pcRevampType]);
  }

  protected onLessonSelectEvent(event: LiveClassEventDto): void {
    if (this.liveClass && event.data === this.liveClass.id) {
      this.confirmSignUp();
    } else {
      this.setLockedState(LIVE_CLASS_LOCKED_STATE_KEYS.SUBSCRIBE[this.pcRevampType]);
    }
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-section/class-tile/group-class-tile.ts